import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getDiscoverPageUrl } from '@/utils/urls';

type RouteParams = {
    topic: string;
};

export const useDiscoverPageCanonicalUrl = () => {
    const baseUrl = useAppSelector(getBaseUrl);
    const { topic } = useParams<RouteParams>();

    return useMemo(() => `${baseUrl}${getDiscoverPageUrl(topic)}`, [baseUrl, topic]);
};
